import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  bg: {
    translation: {
      nav: {
        home: 'Начало',
        about: 'За нас',
        events: 'Събития',
        gallery: 'Галерия',
        shop: 'Магазин',
        donate: 'Дарете'
      },
      hero: {
        tagline: 'Съединени от миналото, обединени за бъдещето.',
        subtitle: 'Подкрепа за младото поколение футболисти чрез наследството на златното поколение от 1994',
        cta: 'Дарете сега'
      },
      mission: {
        title: 'Нашата мисия',
        description: 'Фондация Национали \'94 е посветена на запазването на наследството на златното поколение български футболисти от 1994 година, като същевременно инвестира в бъдещето на младите таланти.',
        vision: 'Вярваме, че духът на \'94 може да вдъхнови следващото поколение шампиони.'
      },
      impact: {
        title: 'Нашето въздействие',
        kids: 'Деца подкрепени',
        funds: 'Събрани средства',
        events: 'Събития организирани'
      },
      donate: {
        title: 'Дарете',
        subtitle: 'Вашето дарение пряко подкрепя младите футболисти в България',
        custom: 'Персонализирана сума',
        recurring: 'Месечно дарение',
        amount: 'Сума',
        currency: 'Валута',
        donate: 'Дарете',
        processing: 'Обработване...',
        goal: 'Годишна цел',
        raised: 'Събрани'
      },
      events: {
        title: 'Събития',
        subtitle: 'Присъединете се към нашите събития и станете част от общността',
        all: 'Всички',
        charitymatch: 'Благотворителен Мач',
        charitygolf: 'Благотворителен турнир по голф',
        charity: 'Благотворителност',
        gala: 'Гала',
        buyTickets: 'Купете билети',
        addCalendar: 'Добавете в календар'
      },
      about: {
        title: 'За нас',
        missionTitle: 'Нашата мисия',
        missionText: 'Да запазим наследството на златното поколение от \'94 и да вдъхновим следващите шампиони.',
        foundersTitle: 'Основатели',
        legendsTitle: 'Легенди от \'94'
      },
      gallery: {
        title: 'Галерия',
        subtitle: 'Спомени от събития',
        all: 'Всички',
        events: 'Събития',
        team: 'Отбор'
      },
      shop: {
        title: 'Магазин',
        subtitle: 'Официални продукти Национали \'94',
        addToCart: 'Добави в количка',
        cart: 'Количка',
        checkout: 'Поръчай',
        empty: 'Вашата количка е празна',
        total: 'Общо'
      },
      footer: {
        tagline: 'Съединени от миналото, обединени за бъдещето',
        newsletter: 'Абонирайте се за новини',
        subscribe: 'Абонирай се',
        email: 'Вашият имейл',
        links: 'Връзки',
        legal: 'Правна информация',
        privacy: 'Поверителност',
        terms: 'Условия',
        contact: 'Контакти',
        rights: 'Всички права запазени'
      },
      success: {
        title: 'Благодарим ви!',
        message: 'Вашето дарение беше успешно обработено.',
        back: 'Обратно към начало'
      },
      cancel: {
        title: 'Плащането е отменено',
        message: 'Вашето плащане беше отменено. Можете да опитате отново.',
        back: 'Опитай отново'
      }
    }
  },
  en: {
    translation: {
      nav: {
        home: 'Home',
        about: 'About',
        events: 'Events',
        gallery: 'Gallery',
        shop: 'Shop',
        donate: 'Donate'
      },
      hero: {
        tagline: 'United by the past, together for the future.',
        subtitle: 'Supporting the next generation of football talent through the legacy of the golden generation of 1994',
        cta: 'Donate Now'
      },
      mission: {
        title: 'Our Mission',
        description: 'The Nationals \'94 Foundation is dedicated to preserving the legacy of Bulgaria\'s golden generation of footballers from 1994, while investing in the future of young talent.',
        vision: 'We believe the spirit of \'94 can inspire the next generation of champions.'
      },
      impact: {
        title: 'Our Impact',
        kids: 'Kids Supported',
        funds: 'Funds Raised',
        events: 'Events Organized'
      },
      donate: {
        title: 'Donate',
        subtitle: 'Your donation directly supports young footballers in Bulgaria',
        custom: 'Custom Amount',
        recurring: 'Monthly Donation',
        amount: 'Amount',
        currency: 'Currency',
        donate: 'Donate',
        processing: 'Processing...',
        goal: 'Annual Goal',
        raised: 'Raised'
      },
      events: {
        title: 'Events',
        subtitle: 'Join our events and be part of the community',
        all: 'All',
        charitymatch: 'Charity Match',
        charitygolf: 'Charity golf tournament',
        charity: 'Charity',
        gala: 'Gala',
        buyTickets: 'Buy Tickets',
        addCalendar: 'Add to Calendar'
      },
      about: {
        title: 'About Us',
        missionTitle: 'Our Mission',
        missionText: 'To preserve the legacy of the golden generation of \'94 and inspire the next generation of champions.',
        foundersTitle: 'Founders',
        legendsTitle: 'Legends of \'94'
      },
      gallery: {
        title: 'Gallery',
        subtitle: 'Memories from events',
        all: 'All',
        events: 'Events',
        team: 'Team'
      },
      shop: {
        title: 'Shop',
        subtitle: 'Official Nationals \'94 Merchandise',
        addToCart: 'Add to Cart',
        cart: 'Cart',
        checkout: 'Checkout',
        empty: 'Your cart is empty',
        total: 'Total'
      },
      footer: {
        tagline: 'United by the past, together for the future',
        newsletter: 'Subscribe to our newsletter',
        subscribe: 'Subscribe',
        email: 'Your email',
        links: 'Links',
        legal: 'Legal',
        privacy: 'Privacy',
        terms: 'Terms',
        contact: 'Contact',
        rights: 'All rights reserved'
      },
      success: {
        title: 'Thank You!',
        message: 'Your donation was processed successfully.',
        back: 'Back to Home'
      },
      cancel: {
        title: 'Payment Cancelled',
        message: 'Your payment was cancelled. You can try again.',
        back: 'Try Again'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'bg',
    fallbackLng: 'bg',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;